export const constantes = {
  ADM_LEVEL_MAX_EXPAND : 4,
  CMP_LEVEL_MAX_EXPAND : 1,
  application: 'demat',
};
